// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'

import { StyleSheet, Text, View } from '@react-pdf/renderer'
import PatientChartsPrintedFriendlySectionItem from '../PatientChartsPrintedFriendlySectionItem/PatientChartsPrintedFriendlySectionItem'
import PatientChartsPrintedFriendlyPastVisitNotes from '../PatientChartsPrintedFriendlyPastVisitNotes/PatientChartsPrintedFriendlyPastVisitNotes'
import PatientChartsPrintedFriendlyIntakeForms from '../PatientChartsPrintedFriendlyIntakeForms/PatientChartsPrintedFriendlyIntakeForms'

const styles = StyleSheet.create({
  reportSection: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: 16,
  },
  separateLine: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: '#C2D5E2',
    borderBottomStyle: 'solid',
  },
  sectionTitle: {
    color: '#141414',
    textAlign: 'right',
    fontFamily: 'Helvetica-Bold',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 16,
  },
  sectionTitlePastVisitNotes: {
    color: '#141414',
    textAlign: 'right',
    fontFamily: 'Helvetica-Bold',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: '700',
  },
  emptyText: {
    color: '#141414',
    textAlign: 'left',
    fontFamily: 'Helvetica',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 16,
    marginTop: 16,
  },
  sectionSubTitle: {
    color: '#141414',
    textAlign: 'right',
    fontFamily: 'Helvetica-BoldOblique',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 16,
  },
})

const PatientChartsPrintedFriendlySection = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  title,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  properties,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isPastVisitVariant,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isIntakeFormVariant,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  emptyText,
}) => {
  if (!properties?.length) {
    return (
      <View style={styles.reportSection}>
        <Text style={styles.sectionTitlePastVisitNotes}>{title}</Text>
        <Text style={styles.emptyText}>{emptyText}</Text>;
        <View style={styles.separateLine} />
      </View>
    )
  }
  if (isIntakeFormVariant) {
    return (
      <View style={styles.reportSection}>
        <Text style={styles.sectionTitlePastVisitNotes}>{title}</Text>
        <PatientChartsPrintedFriendlyIntakeForms properties={properties} />
        <View style={styles.separateLine} />
      </View>
    )
  }
  if (isPastVisitVariant) {
    return (
      <View style={styles.reportSection}>
        <Text style={styles.sectionTitlePastVisitNotes}>{title}</Text>
        <PatientChartsPrintedFriendlyPastVisitNotes properties={properties} />
        <View style={styles.separateLine} />
      </View>
    )
  }
  return (
    <View style={styles.reportSection}>
      <Text style={styles.sectionTitle}>{title}</Text>
      {/*
       // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
      {properties?.map(({ content, propertyTitle, isAllergy, allergyName }) => (
        <PatientChartsPrintedFriendlySectionItem
          isAllergy={isAllergy}
          allergyName={allergyName}
          key={propertyTitle}
          content={content}
          propertyItemName={propertyTitle}
        />
      ))}
      <View style={styles.separateLine} />
    </View>
  )
}

export default PatientChartsPrintedFriendlySection
